import React, { useState } from "react";
import "./UpdateExcelProvAdmin.css";
import * as XLSX from "xlsx";
import axios from "axios";
import Swal from "sweetalert2";
import LoaderExcel from "../../components/LoaderExcel/LoaderExcel";
import { format } from "date-fns";

const UpdateExcelProvAdmin = () => {
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);

  const handleFileChange = (e) => {
    let fileInput = e.target;
    const file = fileInput.files[0];

    if (file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const peopleData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

        const formattedData = peopleData
          .filter((row) => row && Object.keys(row).length > 0) // Filtrar filas vacías
          .map((row) => {
            // Verificar si las columnas necesarias existen en la fila
            if (!row.COMERCIALIZADOR) {
              return null;
            }

            const newRow = {
              ...row,
              COMERCIALIZADOR: row.COMERCIALIZADOR.toUpperCase(),
            };

            if (row.FECHA && typeof row.FECHA === "number") {
              const dateValue = XLSX.SSF.parse_date_code(row.FECHA);
              if (dateValue) {
                newRow.FECHA = format(
                  new Date(dateValue.y, dateValue.m - 1, dateValue.d),
                  "d/M/yyyy"
                );
              }
            }

            return newRow;
          })
          .filter((row) => row !== null); // Elimina cualquier entrada nula

        submitData(formattedData);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const submitData = async (peopleData) => {
    setLoaderTrueFalse(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_LOAD_SALES_XLSX_ADMIN_SUPPLIER}`,
        peopleData
      );
      if (response.status === 200) {
        setLoaderTrueFalse(false);
        // Verificar si hay errores en la respuesta
        if (response.data.errors && response.data.errors.length > 0) {
          // Si hay errores, mostrar la lista de errores
          const errorList = response.data.errors
            .map((error) => `<li>${error}</li>`)
            .join("");
          Swal.fire({
            icon: "success",
            title: "Éxito",
            html: `
            <p>${response.data.message}</p>
            <p>Los siguientes ventas no fueron cargadas:</p>
            <ul style="text-align: left; margin: 20px 0;">${errorList}</ul>
          `,
            customClass: {
              content: "multiline-alert",
            },
          });
        } else {
          setLoaderTrueFalse(false);
          // Si no hay errores, mostrar el mensaje de éxito
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Todas las ventas fueron cargadas.",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        }
      }
    } catch (error) {
      setLoaderTrueFalse(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error.response.data.message ||
          "Hubo un error al procesar la solicitud.",
      });
    }
  };

  return (
    <div className="box-load-xml">
      {LoaderTrueFalse === true ? <LoaderExcel /> : null}
      <label className="custum-file-upload-amebo-prov" htmlFor="file">
        <div className="icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24">
            <g strokeWidth="0" id="SVGRepo_bgCarrier"></g>
            <g
              strokeLinejoin="round"
              strokeLinecap="round"
              id="SVGRepo_tracerCarrier"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill=""
                d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                clipRule="evenodd"
                fillRule="evenodd"
              ></path>
            </g>
          </svg>
        </div>
        <div className="text">
          <span>Haga Click para subir un archivo de ventas</span>
        </div>
        <input type="file" id="file" onChange={handleFileChange}></input>
      </label>
    </div>
  );
};

export default UpdateExcelProvAdmin;
